export default {
    fhd: {
        width: 1920,
        height: 1080,
    },
    qhd: {
        width: 2560,
        height: 1440,
    },
    uhd: {
        width: 3840,
        height: 2160,
    }
};